import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";
export const useLayoutStyles = makeStyles()((theme) => ({
    layoutRoot: {
        display: "flex",
        width: "100%",
        minHeight: "100vh",
        flexDirection: "column",
        fontSize: "1.2rem",
        backgroundColor: constants.color.black,
    },
    body: {
        alignSelf: "center",
        flex: "1 1 auto",
        width: "100%",
        maxWidth: constants.dimensions.maxWidth,
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
}));
